const isDevelopment = process.env.NODE_ENV === 'development';

const RAILWAY_API_URL = 'https://web-production-d89d.up.railway.app';

const API_BASE_URL = isDevelopment 
  ? 'http://localhost:5000/api'
  : `${RAILWAY_API_URL}/api`;

export default API_BASE_URL;
